/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  PsChapterList,
  ErrorInfo,
  LegalRegion,
  PsVersion,
  Ps,
  GetPsParams,
  PsUpdates,
  GetPsUpdateListParams,
  PsTemps,
  GetPsTempListParams,
  PsTempHistories,
  BinaryFile,
  PsDownloadCondition,
  PostPsContent200,
  PostPsContentBody,
  PostPsContentcheck200,
  PostPsContentcheckBody
} from '.././model'


/**
 * PS章一覧を取得する(プルダウン表示用)
 * @summary PS章一覧取得
 */
export const getPsChapterList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PsChapterList>> => {
    return axios.get(
      `/pss/chapterlist`,options
    );
  }


export const getGetPsChapterListQueryKey = () => [`/pss/chapterlist`];

    
export type GetPsChapterListQueryResult = NonNullable<Awaited<ReturnType<typeof getPsChapterList>>>
export type GetPsChapterListQueryError = AxiosError<ErrorInfo>

export const useGetPsChapterList = <TData = Awaited<ReturnType<typeof getPsChapterList>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsChapterList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsChapterListQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsChapterList>>> = ({ signal }) => getPsChapterList({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsChapterList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * テキスト確定条件一覧を取得する(プルダウン表示用)
 * @summary テキスト確定条件一覧取得
 */
export const getPsTextConditionList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    return axios.get(
      `/pss/textconditionlist`,options
    );
  }


export const getGetPsTextConditionListQueryKey = () => [`/pss/textconditionlist`];

    
export type GetPsTextConditionListQueryResult = NonNullable<Awaited<ReturnType<typeof getPsTextConditionList>>>
export type GetPsTextConditionListQueryError = AxiosError<ErrorInfo>

export const useGetPsTextConditionList = <TData = Awaited<ReturnType<typeof getPsTextConditionList>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsTextConditionList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsTextConditionListQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsTextConditionList>>> = ({ signal }) => getPsTextConditionList({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsTextConditionList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 図面番号一覧を取得する(プルダウン表示用)
 * @summary 図面番号一覧取得
 */
export const getPsDrawingNoList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    return axios.get(
      `/pss/drawingnolist`,options
    );
  }


export const getGetPsDrawingNoListQueryKey = () => [`/pss/drawingnolist`];

    
export type GetPsDrawingNoListQueryResult = NonNullable<Awaited<ReturnType<typeof getPsDrawingNoList>>>
export type GetPsDrawingNoListQueryError = AxiosError<ErrorInfo>

export const useGetPsDrawingNoList = <TData = Awaited<ReturnType<typeof getPsDrawingNoList>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsDrawingNoList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsDrawingNoListQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsDrawingNoList>>> = ({ signal }) => getPsDrawingNoList({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsDrawingNoList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Section一覧を取得する(プルダウン表示用)
 * @summary Section一覧取得
 */
export const getPsSectionList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    return axios.get(
      `/pss/sectionlist`,options
    );
  }


export const getGetPsSectionListQueryKey = () => [`/pss/sectionlist`];

    
export type GetPsSectionListQueryResult = NonNullable<Awaited<ReturnType<typeof getPsSectionList>>>
export type GetPsSectionListQueryError = AxiosError<ErrorInfo>

export const useGetPsSectionList = <TData = Awaited<ReturnType<typeof getPsSectionList>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsSectionList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsSectionListQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsSectionList>>> = ({ signal }) => getPsSectionList({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsSectionList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Feature一覧を取得する(プルダウン表示用)
 * @summary Feature一覧取得
 */
export const getPsFeatureList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    return axios.get(
      `/pss/featurelist`,options
    );
  }


export const getGetPsFeatureListQueryKey = () => [`/pss/featurelist`];

    
export type GetPsFeatureListQueryResult = NonNullable<Awaited<ReturnType<typeof getPsFeatureList>>>
export type GetPsFeatureListQueryError = AxiosError<ErrorInfo>

export const useGetPsFeatureList = <TData = Awaited<ReturnType<typeof getPsFeatureList>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsFeatureList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsFeatureListQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsFeatureList>>> = ({ signal }) => getPsFeatureList({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsFeatureList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * Item一覧を取得する(プルダウン表示用)
 * @summary Item一覧取得
 */
export const getPsItemList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string[]>> => {
    return axios.get(
      `/pss/itemlist`,options
    );
  }


export const getGetPsItemListQueryKey = () => [`/pss/itemlist`];

    
export type GetPsItemListQueryResult = NonNullable<Awaited<ReturnType<typeof getPsItemList>>>
export type GetPsItemListQueryError = AxiosError<ErrorInfo>

export const useGetPsItemList = <TData = Awaited<ReturnType<typeof getPsItemList>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsItemList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsItemListQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsItemList>>> = ({ signal }) => getPsItemList({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsItemList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 法規適用国一覧を取得する(チェックボックスリスト表示用)
 * @summary 法規適用国一覧取得
 */
export const getPsLegalRegionList = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<LegalRegion[]>> => {
    return axios.get(
      `/pss/legalregionlist`,options
    );
  }


export const getGetPsLegalRegionListQueryKey = () => [`/pss/legalregionlist`];

    
export type GetPsLegalRegionListQueryResult = NonNullable<Awaited<ReturnType<typeof getPsLegalRegionList>>>
export type GetPsLegalRegionListQueryError = AxiosError<ErrorInfo>

export const useGetPsLegalRegionList = <TData = Awaited<ReturnType<typeof getPsLegalRegionList>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsLegalRegionList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsLegalRegionListQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsLegalRegionList>>> = ({ signal }) => getPsLegalRegionList({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsLegalRegionList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * PSバージョン一覧を取得する(PS比較画面用)

 * @summary PSバージョン一覧取得
 */
export const getPsVersionList = (
    psVersionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PsVersion[]>> => {
    return axios.get(
      `/pss/versionlist/${psVersionId}`,options
    );
  }


export const getGetPsVersionListQueryKey = (psVersionId: number,) => [`/pss/versionlist/${psVersionId}`];

    
export type GetPsVersionListQueryResult = NonNullable<Awaited<ReturnType<typeof getPsVersionList>>>
export type GetPsVersionListQueryError = AxiosError<ErrorInfo>

export const useGetPsVersionList = <TData = Awaited<ReturnType<typeof getPsVersionList>>, TError = AxiosError<ErrorInfo>>(
 psVersionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsVersionList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsVersionListQueryKey(psVersionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsVersionList>>> = ({ signal }) => getPsVersionList(psVersionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsVersionList>>, TError, TData>(queryKey, queryFn, {enabled: !!(psVersionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * PS情報を新規追加する。

 * @summary PS情報新規追加
 */
export const postPsAdd = (
    ps: Ps, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Ps>> => {
    return axios.post(
      `/pss/add`,
      ps,options
    );
  }



    export type PostPsAddMutationResult = NonNullable<Awaited<ReturnType<typeof postPsAdd>>>
    export type PostPsAddMutationBody = Ps
    export type PostPsAddMutationError = AxiosError<ErrorInfo>

    export const usePostPsAdd = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsAdd>>, TError,{data: Ps}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsAdd>>, {data: Ps}> = (props) => {
          const {data} = props ?? {};

          return  postPsAdd(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsAdd>>, TError, {data: Ps}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PS情報を取得する。

 * @summary PS情報取得
 */
export const getPs = (
    psVersionId: number,
    params?: GetPsParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Ps>> => {
    return axios.get(
      `/pss/${psVersionId}`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetPsQueryKey = (psVersionId: number,
    params?: GetPsParams,) => [`/pss/${psVersionId}`, ...(params ? [params]: [])];

    
export type GetPsQueryResult = NonNullable<Awaited<ReturnType<typeof getPs>>>
export type GetPsQueryError = AxiosError<ErrorInfo>

export const useGetPs = <TData = Awaited<ReturnType<typeof getPs>>, TError = AxiosError<ErrorInfo>>(
 psVersionId: number,
    params?: GetPsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPs>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsQueryKey(psVersionId,params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPs>>> = ({ signal }) => getPs(psVersionId,params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPs>>, TError, TData>(queryKey, queryFn, {enabled: !!(psVersionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * PS情報を更新する。

 * @summary PS情報更新
 */
export const postPsEdit = (
    psVersionId: number,
    ps: Ps, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Ps>> => {
    return axios.post(
      `/pss/${psVersionId}/edit`,
      ps,options
    );
  }



    export type PostPsEditMutationResult = NonNullable<Awaited<ReturnType<typeof postPsEdit>>>
    export type PostPsEditMutationBody = Ps
    export type PostPsEditMutationError = AxiosError<ErrorInfo>

    export const usePostPsEdit = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsEdit>>, TError,{psVersionId: number;data: Ps}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsEdit>>, {psVersionId: number;data: Ps}> = (props) => {
          const {psVersionId,data} = props ?? {};

          return  postPsEdit(psVersionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsEdit>>, TError, {psVersionId: number;data: Ps}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PS情報を一件削除する。

 * @summary PS情報削除
 */
export const postPsDelete = (
    psVersionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/pss/${psVersionId}/delete`,undefined,options
    );
  }



    export type PostPsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof postPsDelete>>>
    
    export type PostPsDeleteMutationError = AxiosError<ErrorInfo>

    export const usePostPsDelete = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsDelete>>, TError,{psVersionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsDelete>>, {psVersionId: number}> = (props) => {
          const {psVersionId} = props ?? {};

          return  postPsDelete(psVersionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsDelete>>, TError, {psVersionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PS更新履歴一覧を取得して返す。(改訂日時降順。最大100件)

 * @summary PS更新履歴一覧取得
 */
export const getPsUpdateList = (
    params?: GetPsUpdateListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PsUpdates>> => {
    return axios.get(
      `/pss/updatelist`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetPsUpdateListQueryKey = (params?: GetPsUpdateListParams,) => [`/pss/updatelist`, ...(params ? [params]: [])];

    
export type GetPsUpdateListQueryResult = NonNullable<Awaited<ReturnType<typeof getPsUpdateList>>>
export type GetPsUpdateListQueryError = AxiosError<ErrorInfo>

export const useGetPsUpdateList = <TData = Awaited<ReturnType<typeof getPsUpdateList>>, TError = AxiosError<ErrorInfo>>(
 params?: GetPsUpdateListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsUpdateList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsUpdateListQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsUpdateList>>> = ({ signal }) => getPsUpdateList(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsUpdateList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * PS改廃案一覧を取得して返す。(更新日降順)

 * @summary PS改廃案一覧取得
 */
export const getPsTempList = (
    params?: GetPsTempListParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PsTemps>> => {
    return axios.get(
      `/pss/templist`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetPsTempListQueryKey = (params?: GetPsTempListParams,) => [`/pss/templist`, ...(params ? [params]: [])];

    
export type GetPsTempListQueryResult = NonNullable<Awaited<ReturnType<typeof getPsTempList>>>
export type GetPsTempListQueryError = AxiosError<ErrorInfo>

export const useGetPsTempList = <TData = Awaited<ReturnType<typeof getPsTempList>>, TError = AxiosError<ErrorInfo>>(
 params?: GetPsTempListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsTempList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsTempListQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsTempList>>> = ({ signal }) => getPsTempList(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsTempList>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * PS状態履歴一覧を取得する。

 * @summary PS状態履歴一覧取得
 */
export const getPsHistoryList = (
    psVersionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PsTempHistories>> => {
    return axios.get(
      `/pss/historylist/${psVersionId}`,options
    );
  }


export const getGetPsHistoryListQueryKey = (psVersionId: number,) => [`/pss/historylist/${psVersionId}`];

    
export type GetPsHistoryListQueryResult = NonNullable<Awaited<ReturnType<typeof getPsHistoryList>>>
export type GetPsHistoryListQueryError = AxiosError<ErrorInfo>

export const useGetPsHistoryList = <TData = Awaited<ReturnType<typeof getPsHistoryList>>, TError = AxiosError<ErrorInfo>>(
 psVersionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsHistoryList>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsHistoryListQueryKey(psVersionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsHistoryList>>> = ({ signal }) => getPsHistoryList(psVersionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsHistoryList>>, TError, TData>(queryKey, queryFn, {enabled: !!(psVersionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 図面リストをExcel形式でダウンロードする。

 * @summary 図面リストダウンロード
 */
export const getPsDrawingListDownload = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.get(
      `/pss/drawinglist/download`,options
    );
  }


export const getGetPsDrawingListDownloadQueryKey = () => [`/pss/drawinglist/download`];

    
export type GetPsDrawingListDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof getPsDrawingListDownload>>>
export type GetPsDrawingListDownloadQueryError = AxiosError<ErrorInfo>

export const useGetPsDrawingListDownload = <TData = Awaited<ReturnType<typeof getPsDrawingListDownload>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsDrawingListDownload>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsDrawingListDownloadQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsDrawingListDownload>>> = ({ signal }) => getPsDrawingListDownload({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsDrawingListDownload>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * ダウンロード用のPS情報Excelファイルを生成バッチ処理をジョブに登録する。

 * @summary PS情報Excelファイル生成バッチ処理ジョブ登録
 */
export const postPsDownloadAdd = (
    psDownloadCondition: PsDownloadCondition, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<string>> => {
    return axios.post(
      `/pss/download/add`,
      psDownloadCondition,options
    );
  }



    export type PostPsDownloadAddMutationResult = NonNullable<Awaited<ReturnType<typeof postPsDownloadAdd>>>
    export type PostPsDownloadAddMutationBody = PsDownloadCondition
    export type PostPsDownloadAddMutationError = AxiosError<ErrorInfo>

    export const usePostPsDownloadAdd = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsDownloadAdd>>, TError,{data: PsDownloadCondition}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsDownloadAdd>>, {data: PsDownloadCondition}> = (props) => {
          const {data} = props ?? {};

          return  postPsDownloadAdd(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsDownloadAdd>>, TError, {data: PsDownloadCondition}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 指定したIDのジョブバッチ処理で生成したPS情報Excelファイルをダウンロード出来るかどうかチェックする。

 * @summary PS情報Excelファイルダウンロードチェック
 */
export const postPsDownloadCheck = (
    batchId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<number>> => {
    return axios.post(
      `/pss/${batchId}/download/check`,undefined,options
    );
  }



    export type PostPsDownloadCheckMutationResult = NonNullable<Awaited<ReturnType<typeof postPsDownloadCheck>>>
    
    export type PostPsDownloadCheckMutationError = AxiosError<ErrorInfo>

    export const usePostPsDownloadCheck = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsDownloadCheck>>, TError,{batchId: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsDownloadCheck>>, {batchId: string}> = (props) => {
          const {batchId} = props ?? {};

          return  postPsDownloadCheck(batchId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsDownloadCheck>>, TError, {batchId: string}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 指定したIDのジョブバッチ処理で生成したPS情報Excelファイルをダウンロードする。

 * @summary PS情報Excelファイルダウンロード
 */
export const postPsDownloadBatch = (
    batchId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/pss/${batchId}/download`,undefined,options
    );
  }



    export type PostPsDownloadBatchMutationResult = NonNullable<Awaited<ReturnType<typeof postPsDownloadBatch>>>
    
    export type PostPsDownloadBatchMutationError = AxiosError<ErrorInfo>

    export const usePostPsDownloadBatch = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsDownloadBatch>>, TError,{batchId: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsDownloadBatch>>, {batchId: string}> = (props) => {
          const {batchId} = props ?? {};

          return  postPsDownloadBatch(batchId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsDownloadBatch>>, TError, {batchId: string}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ダウンロード用のPS情報Excelファイルを生成バッチ処理をキャンセルする。

 * @summary PS情報Excel生成バッチ処理キャンセル
 */
export const postPsDownloadCancel = (
    batchId: string, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/pss/${batchId}/download/cancel`,undefined,options
    );
  }



    export type PostPsDownloadCancelMutationResult = NonNullable<Awaited<ReturnType<typeof postPsDownloadCancel>>>
    
    export type PostPsDownloadCancelMutationError = AxiosError<ErrorInfo>

    export const usePostPsDownloadCancel = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsDownloadCancel>>, TError,{batchId: string}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsDownloadCancel>>, {batchId: string}> = (props) => {
          const {batchId} = props ?? {};

          return  postPsDownloadCancel(batchId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsDownloadCancel>>, TError, {batchId: string}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PSイラストデータを取得する(署名付きURLによるアクセスが必要)

 * @summary PSイラストデータ取得
 */
export const getPsIllust = (
    psIllustId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.get(
      `/pss/illust/${psIllustId}`,options
    );
  }


export const getGetPsIllustQueryKey = (psIllustId: number,) => [`/pss/illust/${psIllustId}`];

    
export type GetPsIllustQueryResult = NonNullable<Awaited<ReturnType<typeof getPsIllust>>>
export type GetPsIllustQueryError = AxiosError<ErrorInfo>

export const useGetPsIllust = <TData = Awaited<ReturnType<typeof getPsIllust>>, TError = AxiosError<ErrorInfo>>(
 psIllustId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPsIllust>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPsIllustQueryKey(psIllustId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPsIllust>>> = ({ signal }) => getPsIllust(psIllustId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getPsIllust>>, TError, TData>(queryKey, queryFn, {enabled: !!(psIllustId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * PSコンテンツXML内の画像パスをプレビュー可能なURLに変換する。

 * @summary PSコンテンツ変換
 */
export const postPsContent = (
    psVersionId: number,
    postPsContentBody: PostPsContentBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostPsContent200>> => {
    return axios.post(
      `/pss/content/${psVersionId}`,
      postPsContentBody,options
    );
  }



    export type PostPsContentMutationResult = NonNullable<Awaited<ReturnType<typeof postPsContent>>>
    export type PostPsContentMutationBody = PostPsContentBody
    export type PostPsContentMutationError = AxiosError<ErrorInfo>

    export const usePostPsContent = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsContent>>, TError,{psVersionId: number;data: PostPsContentBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsContent>>, {psVersionId: number;data: PostPsContentBody}> = (props) => {
          const {psVersionId,data} = props ?? {};

          return  postPsContent(psVersionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsContent>>, TError, {psVersionId: number;data: PostPsContentBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PSコンテンツ変換前チェック

 * @summary PSコンテンツ変換前チェック
 */
export const postPsContentcheck = (
    psVersionId: number,
    postPsContentcheckBody: PostPsContentcheckBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostPsContentcheck200>> => {
    return axios.post(
      `/pss/contentcheck/${psVersionId}`,
      postPsContentcheckBody,options
    );
  }



    export type PostPsContentcheckMutationResult = NonNullable<Awaited<ReturnType<typeof postPsContentcheck>>>
    export type PostPsContentcheckMutationBody = PostPsContentcheckBody
    export type PostPsContentcheckMutationError = AxiosError<ErrorInfo>

    export const usePostPsContentcheck = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPsContentcheck>>, TError,{psVersionId: number;data: PostPsContentcheckBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPsContentcheck>>, {psVersionId: number;data: PostPsContentcheckBody}> = (props) => {
          const {psVersionId,data} = props ?? {};

          return  postPsContentcheck(psVersionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postPsContentcheck>>, TError, {psVersionId: number;data: PostPsContentcheckBody}, TContext>(mutationFn, mutationOptions)
    }
    